import {createFileRoute} from "@tanstack/react-router";
import {z as zod} from "zod";
import {robustJsonResultClientFetch} from "@vesta/error-handling-remix/fetches/robustJsonResultClientFetch";
import {uniqueUuid} from "@vesta/unique/unique";
import {adminUserDetailValidator, type AdminUserDetail} from "~/domainModels/adminModels/adminUserDetails";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";
import {RouteComponent} from "./-routeComponent";

export const AUTHORIZATIONS_QUERY_KEY = uniqueUuid`b3e1c2d4-7f8a-4b9e-a1c2-d3e4f5a6b7c8`;

export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/a/_adminScaffold/authorization")({
    loader: async ({context}) => {
        const users = await context.queryClient.ensureQueryData<Array<AdminUserDetail>>({
            queryKey: [AUTHORIZATIONS_QUERY_KEY],
            queryFn: async () => {
                const result = await robustJsonResultClientFetch(
                    `${context.intellsysBaseUrl}/sub-system/pluto/admin/user-details/get`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${context.authenticationStatus.accessToken}`,
                        },
                        body: JSON.stringify({}),
                    },
                    zod.array(adminUserDetailValidator),
                );
                if (result.success !== true) {
                    throw new Error("Failed to fetch users");
                }
                return result.data;
            },
        });

        return {
            users,
            intellsysBaseUrl: context.intellsysBaseUrl,
            accessToken: context.authenticationStatus.accessToken,
        };
    },
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
